import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { LoadingButton } from "@mui/lab";
import { CostumerPericiasListPDFDocument, CostumerPericiasListPDFProps } from "../api/useCostumerPericiasListPDFCreator-react-pdf";
import { removeWhiteSpaces } from "../../../../shared/helpers/string";

interface CostumerPericiasListPDFDownloadProps {
  props: CostumerPericiasListPDFProps;
  disabled?: boolean;
}

export const CostumerPericiasListPDFDownload: React.FC<CostumerPericiasListPDFDownloadProps> = ({ props, disabled = false }) => {
  const { costumerName, start, end } = props;
  const fileName = `${removeWhiteSpaces(costumerName)}-${start.toLocaleDateString("pt-BR")}-${end.toLocaleDateString("pt-BR")}.pdf`;

  return (
    <PDFDownloadLink document={<CostumerPericiasListPDFDocument {...props} />} fileName={fileName}>
      {({ loading }: { loading: boolean }) => (
        <LoadingButton fullWidth variant="contained" sx={{ mb: 1, mt: 5 }} disabled={disabled || loading} loading={loading}>
          {loading ? "Gerando PDF..." : "GERAR PDF"}
        </LoadingButton>
      )}
    </PDFDownloadLink>
  );
};
